import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Image from './Image'

export default function LastArticles({data,title}) {
  return (
    <div className="last-articles">
    {title && (
        <h1>{title}</h1>
    )}
    {data.map((item,index) => {
        return <a href={item.category_language.taxonomy} key={index}>
        <div className="image">
            <Image image={item.file} alt={item.category_language.alt?.file} />
        </div>
        <div>
            <h4>
                {item.category_language.name}
            </h4>
            {item.category_language.extra?.date && (
                <span>
                <FontAwesomeIcon icon={faCalendarAlt} />
                &nbsp; {item.category_language.extra?.date}
                </span>
            )}

        </div>
    </a>
    })}
</div>
  )
}
